












import { Vue, Component } from "@/shared/vuepack";

@Component
export default class ElementsFooter extends Vue {
}
